import {P} from '../../../components/info-tip/info-tip';
import {Tooltip, Button} from '@mayo/mayo-ui-gakki';
import {ReactComponent as InfoIcon} from '@common/assets/icon_info-circle.svg';

export const BillingDateSection = function () {
  return (
    <section className={'w-[300px]'}>
      <h3>計薪基準日</h3>
      <P>1.此假別要結算代金時，會依照此日期作為薪資計算的基準。</P>
      <P>2.建議設定為特休假的法定有效期限結束日。(非協商延長後的延長終止日)</P>
    </section>
  );
};
const BillingDateInfo = function () {
  return (
    <Tooltip
      colorScheme="normal"
      isIcon={true}
      mainAxis={8}
      placement="bottom-start"
      content={<BillingDateSection />}
    >
      <Button
        colorSchema={'primary'}
        variant={'simple'}
        icon={<InfoIcon className="w-5 h-5" />}
      />
    </Tooltip>
  );
};

export default BillingDateInfo;
